import {createContext, useState, useEffect} from 'react';
import axios from 'axios';
import { db } from "./Db";

export const UserContext = createContext();

const isLocalhost = Boolean(

    window.location.hostname === 'localhost' || window.location.hostname === '[::1]' ||

    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||

    window.location.hostname.match(/^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)

);

export const Axios = axios.create({
    baseURL: isLocalhost ? 'www/catalog/public/php/' : 'php/',
});

export const UserContextProvider = ({children}) => {

    const [theUser, setUser] = useState(null);

    const [wait, setWait] = useState(false);

    // Logowanie

    const loginUser = async (formData) => {

        setWait(true);

        try {

            const {data} = await Axios.post('login.php', {formData});

            if(data.token){

                if(userDB.length === 0){

                    createUser(data);    

                } else {

                    updateUser(data);

                }

                setUserDB([{username: data.username, personal_id: data.personal_id, role: data.role, first_name: data.first_name, surname: data.surname, hour_rate: data.hour_rate, total_work_time: data.total_work_time, token: data.token}]);

                setWait(false);

                return {message:'Logowanie udane.'};

            }

            setWait(false);

            return {message:data.message};

        } catch(err){

            setWait(false);

            return {success:0, message:'Błąd serwera!'};

        }

    }

    // Wpisywanie użytkownika do lokalnej bazy danych

    const createUser = async (data)=>{

        await db.user.put({index: 1, username: data.username, personal_id: data.personal_id, token: data.token, first_name: data.first_name, surname: data.surname, hour_rate: data.hour_rate, total_work_time: data.total_work_time});

    }

    // Aktualizacja wpisu użytkownika do lokalnej bazy danych

    const updateUser = async (data)=>{

        await db.user.update(1, {username: data.username, personal_id: data.personal_id, token: data.token, first_name: data.first_name, surname: data.surname, hour_rate: data.hour_rate, total_work_time: data.total_work_time});

    }

    // Pobieranie użytkownika z lokalnej bazy danych

    const [userDB, setUserDB] = useState(null);

    useEffect(() => {

        db.user.toArray().then(function(result){

            setUserDB(result);
            
        });

    },[]);

    // Sprawdzanie użytkownika wpisanego do lokalnej bazy danych

    useEffect(() => {

        if(Array.isArray(userDB)){

            asyncCall();

        }

        async function asyncCall(){

            await loggedInCheck();
            
        }
        
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[userDB]);

    const loggedInCheck = async () => {

        if(userDB.length > 0){

            Axios.options('getUser.php', { timeout: 2500 }).then(function(){

                logOnline();

            }).catch((error) => {

                console.log(error);

                setUser({name: '', personal_id: '', role: 'none', first_name: '', surname: '', hour_rate: '', total_work_time: ''});

            });

        } else {

            setUser({name: '', personal_id: '', role: 'none', first_name: '', surname: '', hour_rate: '', total_work_time: ''});

        }
        
    }

    const logOnline = async () => {

        const loginToken = userDB[0].token;

        Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

        if(loginToken){

            const {data} = await Axios.get('getUser.php');

            if(data.success && data.user){

                let userData = data.user[0];

                db.user.update(1, {total_work_time: userData.total_work_time});

                setUser({name: userData.username, personal_id: userData.personal_id, role: userData.role, first_name: userData.first_name, surname: userData.surname, hour_rate: userData.hour_rate, total_work_time: userData.total_work_time});

                return;

            } else if(data.success === 0 && data.message === "User not found"){

                setUser({name: '', personal_id: '', role: 'none', first_name: '', surname: '', hour_rate: '', total_work_time: ''});

            } else {

                setUser({name: '', personal_id: '', role: 'none', first_name: '', surname: '', hour_rate: '', total_work_time: ''});

            }

        } else {

            setUser({name: '', personal_id: '', role: 'none', first_name: '', surname: '', hour_rate: '', total_work_time: ''});

        }

    }

    // Wylogowanie

    const logout = () => {
        db.user.clear();
        setUser(null);
        window.location.reload(true);
    }

    return (
        <UserContext.Provider value={{loginUser,wait, user:theUser,loggedInCheck,logout}}>
            {children}
        </UserContext.Provider>
    );

}

export default UserContextProvider;